import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import StudentDashboard from "@/pages/StudentDashboard";
import SubjectsPage from "@/pages/SubjectsPage";
import SubjectDetail from "@/pages/SubjectDetail";
import TopicPage from "@/pages/TopicPage";
import AITeacherPage from "@/pages/AITeacherPage";
import SolutionAnalyzerPage from "@/pages/SolutionAnalyzerPage";
import ExamCenterPage from "@/pages/ExamCenterPage";
import ExamRunner from "@/pages/ExamRunner";
import LGSCoachPage from "@/pages/LGSCoachPage";
import DailyPlanPage from "@/pages/DailyPlanPage";
import HedefPage from "@/pages/HedefPage";
import YazKampiPage from "@/pages/YazKampiPage";
import KaynaklarPage from "@/pages/KaynaklarPage";
import SettingsPage from "@/pages/SettingsPage";
import ParentDashboard from "@/pages/ParentDashboard";
import StudentLayout from "@/components/StudentLayout";
import ParentLayout from "@/components/ParentLayout";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Yükleniyor…</div>;
  if (!user) return <Navigate to="/giris" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "parent" ? "/veli" : "/"} replace />;
  return children;
}

function RoleRoot() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/giris" replace />;
  return <Navigate to={user.role === "parent" ? "/veli" : "/panel"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/giris" element={<Login />} />
          <Route path="/kayit" element={<Register />} />

          {/* Student */}
          <Route element={<Protected role="student"><StudentLayout /></Protected>}>
            <Route path="/panel" element={<StudentDashboard />} />
            <Route path="/dersler" element={<SubjectsPage />} />
            <Route path="/dersler/:subjectKey" element={<SubjectDetail />} />
            <Route path="/konu/:subjectKey/:topicCode" element={<TopicPage />} />
            <Route path="/ogretmen" element={<AITeacherPage />} />
            <Route path="/cozum-analiz" element={<SolutionAnalyzerPage />} />
            <Route path="/denemeler" element={<ExamCenterPage />} />
            <Route path="/denemeler/:examId" element={<ExamRunner />} />
            <Route path="/koc" element={<LGSCoachPage />} />
            <Route path="/bugun" element={<DailyPlanPage />} />
            <Route path="/hedef" element={<HedefPage />} />
            <Route path="/yaz-kampi" element={<YazKampiPage />} />
            <Route path="/kaynaklar" element={<KaynaklarPage />} />
            <Route path="/ayarlar" element={<SettingsPage />} />
          </Route>

          {/* Parent */}
          <Route element={<Protected role="parent"><ParentLayout /></Protected>}>
            <Route path="/veli" element={<ParentDashboard />} />
            <Route path="/veli/ayarlar" element={<SettingsPage />} />
          </Route>

          <Route path="/" element={<RoleRoot />} />
          <Route path="*" element={<RoleRoot />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
